import React, { useState } from 'react'
import { Link } from 'react-router-dom'

const SecondaryFooter = ({ footer }) => {
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [email, setEmail] = useState('')
    const [showThankYou, setShowThankYou] = useState(false)
    const [showError, setShowError] = useState(false)
    const [errorMsg, setErrorMsg] = useState('')

    const handleSubmit = (e) => {
        e.preventDefault()
        setShowError(false)
        setErrorMsg('')
        if (email.trim() === '' || firstName.trim() === '' || lastName.trim() === '') {
            setErrorMsg('Please fill in all fields.')
            setShowError(true)
            return
        }

        const formData = {
            email: email.trim(),
            first_name: firstName.trim(),
            last_name: lastName.trim(),
            group_id: footer?.mailListForm?.groupId
        }

        fetch(`${process.env.REACT_APP_API_URL}/mailing-list`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(response => response.json())
            .then(data => {
                if (data.status !== '200') {
                    setErrorMsg(data.data)
                    setShowError(true)
                    return
                }
                let dataLayer = window.dataLayer || []
                dataLayer.push({
                    event: 'FormSubmission',
                    formType: 'SignUp',
                    formID: 'StayInTouch'
                })
                setEmail('')
                setShowThankYou(true)
            })
            .catch((error) => {
                console.error('Error:', error)
            })
    }

    const renderForm = () => {
        if (showThankYou) {
            if (footer.mailListForm.successMessage) {
                return <p>{footer.mailListForm.successMessage}</p>
            }
            return null
        }
        return (
            <form className="form" onSubmit={handleSubmit}>
                <div className="two-col-form">
                    <div className="form-group ">
                        <label>
                            First Name
                            <input
                                type="text"
                                id="first_name"
                                name="first_name"
                                className="form-control"
                                placeholder="Joy"
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                required />
                        </label>
                    </div>
                    <div className="form-group">
                        <label>
                            Last Name
                            <input
                                type="text"
                                id="last_name"
                                name="last_name"
                                className="form-control"
                                placeholder="Justice"
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                required />
                        </label>
                    </div>
                </div>
                <div className="form-group">
                    <label>
                        Email Address
                        <input
                            type="email"
                            id="email"
                            name="email"
                            className="form-control"
                            placeholder="joyjustice@example.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required />
                    </label>
                </div>
                {showError && <p className="invalid-feedback">{errorMsg}</p>}
                <button type="submit" className="btn small ">
                    {footer?.mailListForm?.buttonLabel ? footer.mailListForm.buttonLabel : 'Submit'}
                </button>
            </form>
        )
    }

    const renderLinks = () => {
        let allLinks = []
        footer.links.forEach((link, idx) => {
            allLinks.push(<Link key={idx} to={link.url}>{link.title}</Link>)
        })
        return allLinks
    }

    return (
        <div className="secondary-footer" style={{ marginBottom: '100px' }}>
            <div className="link-holder">
                <div className="title-description">
                    <h3>Way Outta No Way</h3>
                    { footer.description &&
                        <p>{footer.description}</p>
                    }
                </div>
                <div className="link-list">
                    {renderLinks()}
                </div>
            </div>
            <div className="contact-holder">
                <h3>Stay in Touch</h3>
                {renderForm()}
            </div>
        </div>
    )
}

export default SecondaryFooter
